import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

export interface InventoryThumbZoneContextValue {
  isThumbZoneOverlayVisible: boolean;
  setThumbZoneOverlayVisible: React.Dispatch<React.SetStateAction<boolean>>;
  toggleThumbZoneOverlay: () => void;
}

const InventoryThumbZoneContext = createContext<InventoryThumbZoneContextValue | null>(null);

interface InventoryThumbZoneProviderProps {
  children: React.ReactNode;
}

export const InventoryThumbZoneProvider = ({ children }: InventoryThumbZoneProviderProps) => {
  const [isThumbZoneOverlayVisible, setThumbZoneOverlayVisible] = useState(false);

  const toggleThumbZoneOverlay = useCallback(() => {
    setThumbZoneOverlayVisible((previous) => !previous);
  }, []);

  const value = useMemo(
    () => ({
      isThumbZoneOverlayVisible,
      setThumbZoneOverlayVisible,
      toggleThumbZoneOverlay,
    }),
    [isThumbZoneOverlayVisible, toggleThumbZoneOverlay],
  );

  return (
    <InventoryThumbZoneContext.Provider value={value}>{children}</InventoryThumbZoneContext.Provider>
  );
};

export function useInventoryThumbZone(): InventoryThumbZoneContextValue {
  const context = useContext(InventoryThumbZoneContext);

  if (!context) {
    throw new Error('useInventoryThumbZone doit être utilisé sous InventoryThumbZoneProvider');
  }

  return context;
}
